export default
{
    methods:
    {
        setInternalValueFromOptions( value )
        {
            // Make sure tracked value is one option if possible. - @return {void}

            if( Array.isArray( value ) )
            {
                this.$data._value = value.map( ( val ) => this.findOptionFromReducedValue( val ) );
            }
            else
            {
                this.$data._value = this.findOptionFromReducedValue( value );
            }
        },

        select( option )
        {
            // Select or deselect a given option. Allow deselect if clearable or if not the only selected option. - @return {void}

            this.$emit( 'option:selecting', option );

            if( !this.isOptionSelected( option ) )
            {
                if( this.taggable && !this.optionExists( option ) )
                {
                    /* @TODO: could we use v-model instead of push-tags? */

                    this.$emit( 'option:created', option );

                    this.pushTag( option );
                }

                if( this.multiple )
                {
                    option = this.selectedValue.concat( option );
                }

                this.updateValue( option );

                this.$emit( 'option:selected', option );
            }
            //else if( this.deselectFromDropdown && ( this.clearable || ( this.multiple && this.selectedValue.length > 1 ) ) )
            else if( this.clearable )
            {
                this.deselect( option );
            }

            this.onAfterSelect( option );
        },

        deselect( option )
        {
            // De-select a given option. @return {void}

            this.$emit( 'option:deselecting', option );

            this.updateValue( this.selectedValue.filter(( val ) => { return !this.optionComparator( val, option ) }) );

            this.$emit( 'option:deselected', option );
        },

        clearSelection()
        {
            // Clears the currently selected value(s) - @return {void}

            this.updateValue( this.multiple ? [] : null );
        },

        onAfterSelect( option )
        {
            // Called from this.select after each selection. - @return {void}

            if( !this.multiple /*this.closeOnSelect*/ )
            {
                this.open = !this.open;

                this?.searchEl?.blur();
            }

            if( this.clearSearchOnSelect )
            {
                this.search = '';
            }
        },

        updateValue( value )
        {
            // Accepts a selected value, updates local state when required, and triggers the input event.

            if( typeof this.modelValue === 'undefined' )
            {
                // Vue select has to manage value
                this.$data._value = value;
            }

            if( value !== null )
            {
                if( Array.isArray( value ) )
                {
                    value = value.map(( val ) => this.reduce( val ));
                }
                else
                {
                    value = this.reduce( value );
                }
            }

            this.$emit( 'update:modelValue', value );
        },

        toggleDropdown( event )
        {
            // Toggle the visibility of the dropdown menu. @return {void}

            event.preventDefault();

            const ignoredButtons =
            [
                ...( ( this.multiple && this.clearable ) ? this.deselectButtons || [ false ] : [ false ] ),
                ...[ ( this.$refs['clearButton'] || false ), /*( this.$refs['openIndicator'] || false ),*/ ( this.$refs['spinnerIndicator'] || false ) ]
            ];

            if( ignoredButtons.filter( Boolean ).some( ( ref ) => ref?.contains( event.target ) || ref === event.target ) )
            {
                this.toggleTimer = Date.now();
            }
            else
            {
                if( this.open /*&& event.target !== this.searchEl*/ )
                {
                    this?.searchEl?.blur();

                    if( !this.searchable )
                    {
                        this.onSearchBlur( event );
                    }

                    /*
                    if( !this.searchable )
                    {
                        this.onSearchBlur( event );
                    }
                    else
                    {
                        this.onSearchBlur( event );
                    }
                    */
                }
                else if( !this.disabled )
                {
                    this.toggleTimer = null;

                    this?.searchEl?.focus();

                    /*
                    if( !this.searchable )
                    {
                        this.onSearchFocus( event );
                    }
                    else
                    {
                        this.searchEl.focus();
                    }
                    */
                }
            }
        },

        isOptionSelected( option )
        {
            // Check if the given option is currently selected. - @return {Boolean} - True when selected | False otherwise

            return this.selectedValue.some( ( value ) => this.optionComparator( value, option ) );
        },

        isOptionDeselectable( option )
        {
            // Can the current option be removed via the dropdown?

            return this.isOptionSelected( option ) && ( /*this.deselectFromDropdown &&*/ this.clearable );
        },

        optionComparator( a, b )
        {
            // Determine if two option objects are matching. - @returns {boolean}

            return this.getOptionKey( a ) === this.getOptionKey( b );
        },

        findOptionFromReducedValue( value )
        {
            // Finds an option from the options where a reduced value matches the passed in value.

            const predicate = ( option ) => JSON.stringify( this.reduce( option ) ) === JSON.stringify( value );

            const matches = [...this.options, ...this.pushedTags].filter( predicate );

            if( matches.length === 1 ) { return matches[0]; }

            /**
             * This second loop is needed to cover an edge case where `taggable` + `reduce`
             * were used in conjunction with a `create-option` that doesn't create a
             * unique reduced value.
             * @see https://github.com/sagalbot/vue-select/issues/1089#issuecomment-597238735
             */

            return ( matches.find( ( match ) => this.optionComparator( match, this.$data._value ) ) || value );
        },

        maybeDeleteValue()
        {
            // Delete the value on Delete keypress when there is no text in the search input, & there's tags to delete

            if( !this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable )
            {
                let value = null;

                if( this.multiple )
                {
                    value = [ ...this.selectedValue.slice(0, this.selectedValue.length - 1) ]
                }

                this.updateValue( value );
            }
        },

        optionExists( option )
        {
            // Determine if an option exists within this.optionList array. - @return {boolean}

            return this.optionList.some( ( _option ) => this.optionComparator( _option, option ) );
        },

        normalizeOptionForSlot( option )
        {
            // Ensures that options are always passed as objects to scoped slots.

            return typeof option === 'object' ? option : { [this.label]: option };
        },

        pushTag( option )
        {
            // If push-tags is true, push the given option to `this.pushedTags`.

            this.pushedTags.push( option );
        },

        onEscape()
        {
            // If there is any text in the search input, remove it. Otherwise, blur the search input to close the dropdown.

            if( !this.search.length )
            {
                this?.searchEl?.blur();
            }
            else
            {
                this.search = '';
            }
        },

        onSearchFocus( event )
        {
            // Open the dropdown on focus.

            let currDate = Date.now();

            if( ( currDate - this.toggleTimer ) > 250 )
            {
                this.toggleTimer = currDate;

                this.open = true;

                this.$emit('search:focus');

                /*
                if( !this.searchable )
                {
                    setTimeout( () => { document.addEventListener( 'mousedown', this.onSearchBlur, { once: true } ); }, 0 );
                }
                */
            }
            else
            {
                this?.searchEl?.blur();
            }
        },

        onSearchBlur( event )
        {
            // Close the dropdown on blur.

            this.toggleTimer = Date.now();

            if( this.mousedown && !this.searching )
            {
                this.mousedown = false;
            }
            else
            {
                const { clearSearchOnSelect, multiple } = this;

                if( this.clearSearchOnBlur({ clearSearchOnSelect, multiple }) )
                {
                    this.search = '';
                }

                this.open = false;

                this.$emit( 'search:blur' );

                event.preventDefault(); return;
            }

            // Fixed bug where no-options message could not be closed
            if( this.search.length === 0 && this.options.length === 0 )
            {
                this.open = false;

                this.$emit( 'search:blur' );

                event.preventDefault(); return;
            }
        },

        onMousedown( event )
        {
            // Event-Handler to help workaround IE11 (probably fixes 10 as well) firing a `blur` event when clicking the dropdown's scrollbar, causing it to collapse abruptly.

            event.preventDefault()

            this.mousedown = true;
        },

        onMouseUp( event )
        {
            // Event-Handler to help workaround IE11 (probably fixes 10 as well)

            if( event.target.tagName !== 'INPUT' )
            {
                this.mousedown = false;
            }
            else
            {
                event.target.focus();

                event.target.addEventListener( 'blur', () => { this.onSearchBlur( event ) }, { once: true } );
            }
        },

        onSearchKeyDown( e )
        {
            // Search <input> KeyBoardEvent handler.

            const preventAndSelect = ( e ) =>
            {
                e.preventDefault();

                return !this.isComposing && this.typeAheadSelect();
            }

            const defaults =
            {
                8   : ( e ) => { return this.maybeDeleteValue() }, //  backspace
                9   : ( e ) => { return this.onTab() }, //  tab
                27  : ( e ) => { return this.onEscape() }, //  esc
                38  : ( e ) => { e.preventDefault(); return this.typeAheadUp(); }, //  up.prevent
                40  : ( e ) => { e.preventDefault(); return this.typeAheadDown() }, //  down.prevent
            }

            this.selectOnKeyCodes.forEach( ( keyCode ) => ( defaults[ keyCode ] = preventAndSelect ) );

            const handlers = this.mapKeydown( defaults, this );

            if( typeof handlers[ e.keyCode ] === 'function' )
            {
                return handlers[ e.keyCode ]( e );
            }
        },

        toggleLoading( toggle = null )
        {
            // Toggle this.loading. Optionally pass a boolean value. If no value is provided, this.loading will be set to the opposite of it's current value.

            if( toggle == null )
            {
                return ( this.mutableLoading = !this.mutableLoading )
            }

            return ( this.mutableLoading = toggle )
        },

        maybeAdjustScroll()
        {
            // Adjust the scroll position of the dropdown list if the current pointer is outside of the overflow bounds.

            const optionEl = this.$refs.dropdown?.children[this.typeAheadPointer] || false;

            if( optionEl )
            {
                const bounds = this.getDropdownViewport();

                const { top, bottom, height } = optionEl.getBoundingClientRect();

                if( top < bounds.top )
                {
                    return ( this.$refs.dropdown.scrollTop = optionEl.offsetTop )
                }
                else if( bottom > bounds.bottom )
                {
                    return ( this.$refs.dropdown.scrollTop = optionEl.offsetTop - ( bounds.height - height ) );
                }
            }
        },

        getDropdownViewport()
        {
            // The currently viewable portion of the dropdown. - @returns {{top: (string|*|number), bottom: *}}

            return this.$refs.dropdown ? this.$refs.dropdown.getBoundingClientRect() : { height: 0, top: 0, bottom: 0 }
        },

        typeAheadUp()
        {
            // Move the typeAheadPointer visually up the list by setting it to the previous selectable option.

            for( let i = this.typeAheadPointer - 1; i >= 0; i-- )
            {
                if( this.selectable( this.filteredOptions[i] ) )
                {
                    this.typeAheadPointer = i; break;
                }
            }
        },

        typeAheadDown()
        {
            // Move the typeAheadPointer visually down the list by setting it to the next selectable option.

            for( let i = this.typeAheadPointer + 1; i < this.filteredOptions.length; i++ )
            {
                if( this.selectable( this.filteredOptions[i] ) )
                {
                    this.typeAheadPointer = i; break;
                }
            }
        },

        typeAheadSelect()
        {
            // Select the option at the current typeAheadPointer position. Optionally clear the search input on selection.

            const typeAheadOption = this.filteredOptions[this.typeAheadPointer];

            if( typeAheadOption && this.selectable( typeAheadOption ) )
            {
                this.select( typeAheadOption );
            }
        },

        typeAheadToLastSelected()
        {
            // Moves the pointer to the last selected option.

            if( this.selectedValue.length !== 0 )
            {
                this.typeAheadPointer = this.filteredOptions.indexOf( this.selectedValue[ this.selectedValue.length - 1 ] );
            }
            else
            {
                this.typeAheadPointer = -1;
            }
        },

        selectedOptionsAttributes( option, index )
        {
            return (
            {
                'option'   : this.normalizeOptionForSlot( option ),
                'deselect' : this.deselect,
                'multiple' : this.multiple,
                'disabled' : this.disabled
            })
        },

        selectedOptionAttributes( option, index )
        {
            let $_key    = this.getOptionKey( option );
            let $_label  = this.getOptionLabel( option );
            let $_option = this.normalizeOptionForSlot( option );

            let $_listeners = {};

            if( this.clearable && this.multiple )
            {
                $_listeners.deselect = () => this.deselect( option );
            }

            return (
            {
                'ref'         : ( el ) => { this.deselectButtons[ index ] = el?.$el; },
                'id'          : $_key,
                'key'         : $_key,
                'label'       : $_label,
                'disabled'    : this.disabled,
                'removeable'  : this.clearable && this.multiple,
                ...$_option,
                ...$_listeners
            })
        },

        optionListAttributes( option, index )
        {
            return (
            {
                'id'              : `vs${this.uid}__option-${index}`,
                'key'             : this.getOptionKey(option),
                'role'            : 'option',
                'aria-selected'   : index === this.typeAheadPointer ? true : null,
                'class'           :
                {
                    'vs-option--deselect'  : this.isOptionDeselectable( option ) && index === this.typeAheadPointer,
                    'vs-option--selected'  : this.isOptionSelected( option ),
                    'vs-option--highlight' : index === this.typeAheadPointer,
                    'vs-option--disabled'  : !this.selectable( option )
                }
            })
        },

        optionListListeners( option, index )
        {
            return (
            {
                mouseover : () => { this.selectable( option ) ? ( this.typeAheadPointer = index ) : null },
                click     : () => { event.preventDefault(); event.stopPropagation(); this.selectable( option ) ? this.select( option ) : null }
            })
        }
    }
}